import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'

import { homeGoalReportService } from '../services/home-goal-report.service'
import type { TGoalReport } from '../types/home-goal-report.type'

export function useDashboardQuery(vendedor = '') {
  const {
    data: goalsReport,
    isFetching: isLoadingGoalsReport,
    refetch: refetchGoalsReport,
  } = useQuery<TGoalReport>({
    enabled: true,
    queryKey: [QUERY_KEYS.GOALS_REPORTS, vendedor],
    queryFn: async () => {
      const response = await homeGoalReportService(vendedor)
      const data = JSON.parse(response.body)
      return data
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000,
  })

  return { goalsReport, isLoadingGoalsReport, refetchGoalsReport }
}
